import { downloadBlob } from '@mint-lib/api-zod-support';
import { useTranslation } from '@mint-lib/i18n';
import { enqueueSnackbar } from '@mint-lib/notifications';
import { useProfile } from '@mint-lib/profile-helpers';
import { useMutation } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useMediaPlan } from '../queries/useMediaPlan.js';

export const useExportMediaPlan = () => {
  const { t } = useTranslation('@myn/planning_v2');

  const { profile } = useProfile();
  const { data: mediaPlan } = useMediaPlan();

  return useMutation({
    mutationFn: (mediaPlanId: string) =>
      MediaPlan.exportMediaPlan({
        urlParams: {
          mediaPlanId,
        },
      }),
    onSuccess: (data) => {
      downloadBlob(
        data,
        `${profile?.profile.company.name} - ${mediaPlan?.name}.xlsx`,
      );
    },
    onError: () => {
      enqueueSnackbar({
        title: t('Something went wrong'),
        subTitle: t('Failed to export media plan'),
        variant: 'error',
        removable: true,
      });
    },
  });
};
